import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { 
  CogIcon, 
  TagIcon, 
  UserIcon,
  BellIcon,
  BuildingOfficeIcon,
  SquaresPlusIcon,
  TableCellsIcon,
  BriefcaseIcon,
  AdjustmentsHorizontalIcon,
  LinkIcon
} from '@heroicons/react/24/outline';

const Settings = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  const navItems = [
    { name: 'Status Types', href: '/settings/status-types', icon: TagIcon },
    { name: 'Departments', href: '/settings/departments', icon: BuildingOfficeIcon },
    { name: 'Groups', href: '/settings/groups', icon: UserIcon },
    { name: 'Types', href: '/settings/types', icon: SquaresPlusIcon },
    { name: 'Project Fields', href: '/settings/project-fields', icon: TableCellsIcon },
    { name: 'Industry Types', href: '/settings/industry-types', icon: BriefcaseIcon },
    { name: 'Vendor Types', href: '/settings/vendor-types', icon: BriefcaseIcon },
    { name: 'Client Custom Fields', href: '/settings/client-custom-fields', icon: AdjustmentsHorizontalIcon },
    { name: 'Association Types', href: '/settings/association-types', icon: LinkIcon },
    // Add more settings sections as needed
    // { name: 'Users', href: '/settings/users', icon: UserIcon },
    // { name: 'Notifications', href: '/settings/notifications', icon: BellIcon },
  ];
  
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Side navigation */}
      <div className="hidden md:flex md:w-64 md:flex-col">
        <div className="flex flex-col flex-grow pt-5 bg-white overflow-y-auto border-r border-gray-200">
          <div className="flex items-center flex-shrink-0 px-4">
            <span className="text-lg font-medium text-gray-900">Settings</span>
          </div>
          <div className="mt-5 flex-grow flex flex-col">
            <nav className="flex-1 px-2 pb-4 space-y-1">
              {navItems.map((item) => {
                const isActive = currentPath.includes(item.href);
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
                      isActive
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                  >
                    <item.icon
                      className={`mr-3 flex-shrink-0 h-6 w-6 ${
                        isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'
                      }`}
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>
      </div>
      
      {/* Mobile menu */}
      <div className="md:hidden p-4 bg-white border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-medium text-gray-900">Settings</h1>
          <div className="flex items-center">
            <label htmlFor="mobile-settings-menu" className="sr-only">
              Select settings page
            </label>
            <select
              id="mobile-settings-menu"
              className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              value={currentPath}
              onChange={(e) => {
                window.location.href = e.target.value;
              }}
            >
              {navItems.map((item) => (
                <option key={item.name} value={item.href}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      {/* Main content area */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings; 